import { useEffect } from "react";
import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";

import useApparelTypeData from "../../../state/apparelType/UseApparelTypeData";
import useNTRegistrationData from "../../../state/nationalTeamRegistration/UseNTRegistrationData";
import useNTRegistrationLeftNavData from "../../../state/nationalTeamRegistration/nationalTeamRegistrationLeftNav/UseNTRegistrationLeftNavData";
import useNTRegistrationPersonData from "../../../state/nationalTeamRegistration/nationalTeamRegistrationPerson/UseNTRegistrationPersonData";

import useNavRoutes from "@usas/ui-web/state/security/UseNavRoutes";

import { LEFT_NAV_ITEM_NAME_APPAREL } from "../utils/NTRegistrationConstants";

const useNTRegistrationApparel = () => {
  const navigate = useNavigate();
  const { navRoutes } = useNavRoutes();
  const { apparelTypeState, getApparelTypes } = useApparelTypeData();
  const { pageHasUnsavedChanges, updatePageHasUnsavedChanges, onNTRegistrationError, onNavigateWithoutSaving
  } = useNTRegistrationData();
  const { nationalTeamRegistrationLeftNavState, updateCurrentLeftNavData } = useNTRegistrationLeftNavData();
  const { nationalTeamRegistrationPersonState, getNTRegistrationPerson, putNTRegistrationPerson } = useNTRegistrationPersonData()

  const onContinueClicked = (event) => {
    try {
      event?.preventDefault();

      if (pageHasUnsavedChanges === true) {
        onNavigateWithoutSaving(navRoutes.NT_REGISTRATION_COACH?.route);
      } else {
        navigate(navRoutes.NT_REGISTRATION_COACH?.route);
      }
    } catch (e) {
      onNTRegistrationError(e);
    }
  };

  const onBackClicked = (event) => {
    try {
      event?.preventDefault();

      if (pageHasUnsavedChanges === true) {
        onNavigateWithoutSaving(navRoutes.NT_REGISTRATION_FREQUENT_FLYER?.route);
      } else {
        navigate(navRoutes.NT_REGISTRATION_FREQUENT_FLYER?.route);
      }
    } catch (e) {
      onNTRegistrationError(e);
    }
  };

  const onSubmitApparelForm = async (personNationalTeamApparel) => {
    try {
      const personId = nationalTeamRegistrationPersonState.objData.personId;
      const newPersonNTObj = JSON.parse(JSON.stringify(nationalTeamRegistrationPersonState.objData));
      newPersonNTObj.personNationalTeamApparel = personNationalTeamApparel;

      updateCurrentLeftNavData(LEFT_NAV_ITEM_NAME_APPAREL, true);

      await putNTRegistrationPerson(personId, newPersonNTObj);
    } catch (e) {
      updateCurrentLeftNavData(LEFT_NAV_ITEM_NAME_APPAREL, true);
      onNTRegistrationError(e);
    }
  };

  useEffect(() => {
    async function loadNTRegistrationPerson() {
      try {
        let apparelState = null;
        let personState = null;

        if (apparelTypeState.isArrayLoaded !== true) {
          updateCurrentLeftNavData(LEFT_NAV_ITEM_NAME_APPAREL);

          apparelState = await getApparelTypes();
        } else {
          apparelState = apparelTypeState;
        }

        if (nationalTeamRegistrationPersonState.isObjLoaded !== true) {
          updateCurrentLeftNavData(LEFT_NAV_ITEM_NAME_APPAREL);

          personState = await getNTRegistrationPerson(0);
        } else {
          personState = nationalTeamRegistrationPersonState;
        }

        updateCurrentLeftNavData(LEFT_NAV_ITEM_NAME_APPAREL, getApparelIsComplete(personState.objData.personNationalTeamApparel, apparelState.arrayData));
      } catch (e) {
        onNTRegistrationError(e);
      }
    }
    loadNTRegistrationPerson();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getApparelIsComplete(personNationalTeamApparel, apparelTypes) {
    if (Array.isArray(personNationalTeamApparel)) {
      for (const apparelType of apparelTypes) {
        const found = personNationalTeamApparel.find((x) => x.nationalTeamApparelId === apparelType.nationalTeamApparelId);

        if (!found) {
          return false;
        }
      }
    }

    return true;
  }

  return {
    isLoading: nationalTeamRegistrationPersonState.isObjLoading || apparelTypeState.areOptionsLoaded !== true,
    personId: nationalTeamRegistrationPersonState.objData?.personId,
    gridData: nationalTeamRegistrationPersonState.objData?.personNationalTeamApparel || [],
    competitionGenderTypeCode: nationalTeamRegistrationLeftNavState.objData?.competitionGenderTypeCode,
    onSubmitApparelForm,
    onContinueClicked,
    onBackClicked,
    onNTRegistrationError,
    updatePageHasUnsavedChanges
  };
};

export default useNTRegistrationApparel;